import { OP_GET_PROP_API, OPTIMIZED_PRODUCT_GET_API_HOMEPAGE, PROPS_API_V2 } from '../../config/constant/apiConstant';
import { MODEL_TYPES } from '../../constants/constants';
import { IMAGE_SEARCH_API, PROPS_API, PROPS_REPLACE_API } from '../../helpers/api';
import { LOADING_KEY } from '../../helpers/reduxHelper';
import { paginatedProductActions } from '../../redux/slicers/admin/paginatedProductSlicer';
import { createDeleteApiAction, createGetListAction, createPostApiAction, createUpdateApiAction } from '../apiGenerator';
import { addTimestampParamInUrl } from '../retailAutomationApis';

export const getProductListApi = createGetListAction({
  endpoint: PROPS_API_V2,
  actions: paginatedProductActions,
  setGlobalSidebarFilters: true,
  formatEndpoint: (u) => addTimestampParamInUrl(u),
});

export const getMy3dModelListApi = createGetListAction({
  endpoint: PROPS_API,
  skipBrandFilter: true,
  actions: paginatedProductActions,
  setGlobalSidebarFilters: true,
  formatEndpoint: (u) => addTimestampParamInUrl(u),
});

export const getProductListOptimizeApi = createGetListAction({
  endpoint: OPTIMIZED_PRODUCT_GET_API_HOMEPAGE,
  actions: paginatedProductActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.PRODUCT,
  formatEndpoint: (u) => addTimestampParamInUrl(u),
});

export const getMy3dModelListOptimizeApi = createGetListAction({
  endpoint: OPTIMIZED_PRODUCT_GET_API_HOMEPAGE,
  skipBrandFilter: true,
  actions: paginatedProductActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.THREEDMODELS,
  formatEndpoint: (u) => addTimestampParamInUrl(u),
});

export const getProductReplaceListApi = createGetListAction({
  endpoint: PROPS_REPLACE_API,
  actions: paginatedProductActions,
  defaultSort: null,
});

export const ProductEditApi = createUpdateApiAction({
  actions: paginatedProductActions,
  endpointUrl: PROPS_API,
  loadingKey: LOADING_KEY.FAVOURITE,
});

export const getProductByImageSearchListApi = createPostApiAction({
  actions: paginatedProductActions,
  endpointUrl: IMAGE_SEARCH_API,
  defaultSort: null,
  setGlobalSidebarFilters: true,
  skipFilterUpdate: true, // Skip updating filters since the image search API doesn't return any filters. Keep the existing filters applied to the search.
  dataFormattter: (item) => {
    return {
      ...item?.product_details,
      imgId: item.id,
      thumbnail: item.image,
      distance: item.distance,
    };
  },
});

export const getMy3DModelByImageSearchListApi = createPostApiAction({
  actions: paginatedProductActions,
  endpointUrl: IMAGE_SEARCH_API,
  defaultSort: null,
  setGlobalSidebarFilters: true,
  skipBrandFilter: true,
  skipFilterUpdate: true, // Skip updating filters since the image search API doesn't return any filters. Keep the existing filters applied to the search.
  dataFormattter: (item) => {
    return {
      ...item?.product_details,
      imgId: item.id,
      thumbnail: item.image,
      distance: item.distance,
    };
  },
});